import React, { useState, useEffect } from 'react';
import { useFetchSearch } from '../hooks/useFetchSearch';
import { useFetchGeom } from '../hooks/useFetchGeom';

const SearchableSelect = ({ geoserverUrl, map, mapLayer, setGeom, load, m2load, onSelect }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [option, setOption] = useState('');
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  
  const mapLegendData = useFetchSearch(geoserverUrl, mapLayer, load);
  const geom = useFetchGeom(geoserverUrl, mapLayer, option );

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleOptionClick = (option) => {
    onSelect(option);
    setSearchTerm(option);
    setOption(option);
    setIsDropdownVisible(false);
    let bounds = mapLegendData.find(item => item.dpa_descan === option).bbox
    map.fitBounds([ [bounds[1], bounds[0] ], [ [bounds[3], bounds[2] ] ] ])
  };

  useEffect( () => {
    setGeom(geom)
}, [geom])
  
  if (mapLegendData !== '') { 
    const mapData = mapLegendData.map(item => item.dpa_descan); 
    const filteredOptions = mapData.filter(mapData =>
    mapData.toLowerCase().includes(searchTerm.toLowerCase())
    );

  if (m2load) return ''
  else {
  return (
    <div className="searchable-select">
      <input
        type="text"
        value={searchTerm}
        onChange={handleSearchChange}
        onFocus={() => setIsDropdownVisible(true)}
        onBlur={() => setTimeout(() => setIsDropdownVisible(false), 200)}
        placeholder="Seleccionar Cantón"
        className="search-input"
      />
      {isDropdownVisible && filteredOptions.length > 0 && (
        <ul className="options-list">
          {filteredOptions.map((option, index) => (
            <li key={index} onClick={() => handleOptionClick(option)}>
              {option}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
};
}

export default SearchableSelect;
